import api from './api';

export default async function deleteKeyword(id, username) {
    const { data } = await api.delete(`misspelling-keyword/${id}?username=${username}`);

    return data;
}